// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/browser-detection/browser-detection.component.scss
// module id = 157
// module chunks = 0